import axios from 'axios';
import MyModal from '../components/session_expired'
import React from "react";
class ApiClient {
  
    constructor(authToken) {
        this.authToken = authToken;
       
    }
    async fetchData(url, method = 'POST', data = {}, params = {}) {
      
        try {
            let response;
            const headers = { 'Authorization': `Bearer ${this.authToken}` };
            if (method.toUpperCase() === 'GET') {
              response = await axios.get(url, { headers, params });
            } else if (method.toUpperCase() === 'POST') {
              response = await axios.post(url, data, {headers});
             
              
            } else {
              console.error('Unsupported HTTP method');
              throw new Error('Unsupported HTTP method');
            }
            console.info('response**',response);
            if(url.includes("addbank/verification")){
              return response.data
            }
            if(url.includes("addbank/edit")){
              return response.data
            }
            if(url.includes("api/document/confirmdocs")){
              return response.data
            }
            if(url.includes("api/fno/createrequest")){
              return response
            }
            if(url.includes("api/fno/request_status")){
              return response
            }
            if(url.includes("ocr_docs")){
              return response
            }
            if(url.includes("setu/account_aggregator/create_consent")){
              return response.data
            }
            if(url.includes("api/fno/request_info")){
              return response.data.data
            }
            if(url.includes("nomination/nomination-previewPDF")){
              return response.data
            }
            if(url.includes("nomination/nomination-eSign")){
              return response.data
            }
            if(url.includes("nomination/nomination-query/")){
              return response.data
            }
             if(url.includes("accountclosure-previewPDF")){
              return response
            }
             if(url.includes("accountclosure-eSign-status")){
              return response.data
            }
              if(url.includes("accountclosure-initiateClosure")){
              return response.data
            }
              if(url.includes("aa-eSign")){
              return response.data
            }
            if(url.includes("bankLogs/failed-record")){
              return response.data
            }

            if(url.includes("bankLogs/upload-doc")){
              return response.data
            }

            if(url.includes("userupdate/send-otp")){
              return response.data
            }

            if(url.includes("userupdate/verify-otp")){
              return response.data
            }

            if(url.includes("userupdate/send-new-otp")){
              return response.data
            }

            if(url.includes("userupdate/verify-new-otp")){
              return response.data
            }

            if(url.includes("userupdate/esign/initiate")){
              return response.data
            }

            if(url.includes("userupdate/update-status")){
              return response.data
            }
             if (url.includes("esign/ddpipreview")) {
            return response.data
            }
            if (url.includes("esign/authorize")) {
              return response.data
            }
            if (url.includes("/ddpi/status")) {
              return response.data
            }
            if (url.includes("/report/client-dp-details")) {
              return response.data
            }
            if (url.includes("contract")) {
              return response.data
            }

            if (url.includes("addbank/rpd-create")) {
              return response.data
            }
            if (url.includes("addbank/rpd-verify")) {
              return response.data
            }

         
            return response.data.data;
           
          } catch (error) {
            console.log('Error',error.response);
            if(url.includes("addbank/edit")){
              return error.response
            }
            if(url.includes("addbank/verification")){
              return error.response
            }
            // Srini - 20/11/24
            if(url.includes("payment/payorder")){
              return error.response.data
            }
            if(url.includes("api/document/confirmdocs")){
              return error.response.data
            }
            if(url.includes("api/fno/createrequest")){
              return error.response
            }
            if(url.includes("api/fno/request_status")){
              return error.response
            }
            if(url.includes("ocr_docs")){
              return error.response
            }
            if(url.includes("nomination/nomination-previewPDF")){
              return error.response
            }
            if(url.includes("nomination/nomination-eSign")){
              return error.response
            }
            if(url.includes("nomination/nomination-query/")){
              return error.response
            }
             if(url.includes("accountclosure-previewPDF")){
             return error.response
            }
             if(url.includes("accountclosure-eSign-status")){
             return error.response
            }
              if(url.includes("accountclosure-initiateClosure")){
              return error.response
            }
              if(url.includes("aa-eSign")){
              return error.response
            }

            if(url.includes("bankLogs/failed-record")){
              return error.response
            }

            if(url.includes("bankLogs/upload-doc")){
              return error.response
            }

            if(url.includes("userupdate/send-otp")){
              return error.response
            }

            if(url.includes("userupdate/verify-otp")){
              return error.response
            }

            if(url.includes("userupdate/send-new-otp")){
              return error.response
            }

            if(url.includes("userupdate/verify-new-otp")){
              return error.response
            }

            if(url.includes("userupdate/esign/initiate")){
              return error.response
            }

            if(url.includes("userupdate/update-status")){
              return error.response
            }
             if (url.includes("esign/ddpipreview")) {
            return error.response
           }
            if (url.includes("esign/authorize")) {
              return error.response
            }
            if (url.includes("/ddpi/ddpi-eSign-status")) {
              return error.response
            }
            if (url.includes("/ddpi/status")) {
              return error.data
            }
            if (url.includes("/report/client-dp-details")) {
              return error.data
            }

            if (url.includes("addbank/rpd-create")) {
              return error.data
            }
            if (url.includes("addbank/rpd-verify")) {
              return error.data
            }

            
            return error.response.status;
          }
    }

    // Add more methods for different API calls as needed
}

export default ApiClient;
